// src/hooks/hotelRatings/useDeleteAllHotelRatings.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllHotelRatings as deleteAllHotelRatingsAPI } from "../../api/apiHotelRatings";
import parseError from "../../utils/parseError";

const useDeleteAllHotelRatings = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAll, isPending: isDeleteAll } = useMutation({
        mutationFn: deleteAllHotelRatingsAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected hotel ratings deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRatings"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete selected hotel ratings");
        },
    });

    return { deleteAllHotelRatings: deleteAll, isDeleteAll };
};

export default useDeleteAllHotelRatings;
